import {Button} from '@/components/ui/button/Button'
import {
    Dialog,
    DialogDisclosure,
    DialogDismiss,
    DialogHeader,
    DialogHeading,
    DialogProvider
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {PrinterIcon} from '@/components/ui/icon/Icon'
import {
    StyledPrintSiarDialogFooter,
    StyledPrintSiarDialogBody
} from '@/features/projects/components/print-siar-dialog/style'
import {PrintSiarFormProvider} from '@/features/projects/components/print-siar-form/print-siar-form-provider/PrintSiarFormProvider'
import {PrintSiarOperatorSignatureField} from '@/features/projects/components/print-siar-form/print-siar-operator-signature-field/PrintSiarOperatorSignatureField'
import {PrintSiarSectionsSelector} from '@/features/projects/components/print-siar-form/print-siar-sections-selector/PrintSiarSectionsSelector'
import {PrintSiarSubmitButton} from '@/features/projects/components/print-siar-form/print-siar-submit-button/PrintSiarSubmitButton'
import {ProjectProgressStatus, ProjectStatus} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import {ComponentType, MouseEvent, useMemo, useState} from 'react'

export const PrintSiarDialog = ({
    projectId,
    status,
    progressStatus,
    projectCode,
    customTrigger: CustomTrigger
}: {
    projectId: string
    status: ProjectStatus
    progressStatus: ProjectProgressStatus
    projectCode: number
    customTrigger?: ComponentType<{onClick: (event?: MouseEvent<HTMLElement>) => void; isDisabled?: boolean}>
}) => {
    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(false)
    const dialogStore = useDialogStore({
        open: isOpen,
        setOpen: setIsOpen
    })

    // const isEnabled = useMemo(() => {
    //     return (
    //         (status == 'open' && progressStatus == 'to_print') ||
    //         (status == 'open' && progressStatus == 'to_export') ||
    //         (status == 'open' && progressStatus == 'to_transmit') ||
    //         (status == 'closed' && progressStatus == 'to_transmit')
    //     )
    // }, [status, progressStatus])

    // Just for testing
    const isEnabled = useMemo(() => {
        return progressStatus == 'to_print' || progressStatus == 'to_export' || progressStatus == 'to_transmit'
    }, [status, progressStatus])

    return (
        <DialogProvider store={dialogStore}>
            <DialogDisclosure
                render={
                    CustomTrigger ? (
                        <CustomTrigger isDisabled={!isEnabled} onClick={() => setIsOpen(true)} />
                    ) : (
                        <Button variant="ghost" disabled={!isEnabled}>
                            <PrinterIcon />
                            {t('projects:print_siar')}
                        </Button>
                    )
                }
            />
            <Dialog width="400px">
                <PrintSiarDialogContent projectId={projectId} projectStatus={status} projectCode={projectCode} />
            </Dialog>
        </DialogProvider>
    )
}

const PrintSiarDialogContent = ({
    projectId,
    projectStatus,
    projectCode
}: {
    projectId: string
    projectStatus: ProjectStatus
    projectCode: number
}) => {
    const {t} = useTranslation()
    const dialog = useDialogContext()
    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('projects:print_siar')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <PrintSiarFormProvider projectId={projectId} projectStatus={projectStatus}>
                <StyledPrintSiarDialogBody>
                    <PrintSiarSectionsSelector />
                    <PrintSiarOperatorSignatureField />
                </StyledPrintSiarDialogBody>
                <StyledPrintSiarDialogFooter>
                    <Button variant="secondary" onClick={() => dialog?.setOpen(false)}>
                        {t('commons:close')}
                    </Button>
                    <PrintSiarSubmitButton projectCode={projectCode} />
                </StyledPrintSiarDialogFooter>
            </PrintSiarFormProvider>
        </>
    )
}
